// Sample data in the shape server-copa returns, used only with REACT_APP_USE_MOCK=true.
import { addDays, isoDate } from '../utils/format';

export const mockLeagues = [
  { Area: 'europe', League: 'champions-league', TeamCode: 'Europe', ImagePath: 'Default' },
  { Area: 'england', League: 'premier-league', TeamCode: 'England', ImagePath: 'Default' },
  { Area: 'england', League: 'championship', TeamCode: 'England', ImagePath: 'Default' },
  { Area: 'spain', League: 'laliga', TeamCode: 'Spain', ImagePath: 'Default' },
  { Area: 'italy', League: 'serie-a', TeamCode: 'Italy', ImagePath: 'Default' },
];

// Blended (bet) probabilities and the model's bet: [H, D, A blend], prediction, amount.
const BETS = [
  [[0.51, 0.25, 0.24], 'H', 4.6],
  [[0.19, 0.57, 0.24], '', 0],
  [[0.36, 0.31, 0.33], '', 0],
  [[0.26, 0.47, 0.27], 'A', 6.0],
  [[0.29, 0.43, 0.28], '', 0],
];

const FIXTURES = [
  ['england', 'premier-league', 'Arsenal', 'Chelsea', '15:00', 0.48, 0.27, 0.25, 2.05, 3.6, 3.7, 'H'],
  ['england', 'premier-league', 'Everton', 'Liverpool', '17:30', 0.21, 0.56, 0.23, 5.2, 1.62, 4.2, 'A'],
  ['spain', 'laliga', 'Sevilla', 'Real Betis', '20:00', 0.39, 0.31, 0.30, 2.7, 2.75, 3.3, 'N'],
  ['italy', 'serie-a', 'Torino', 'AC Milan', '18:00', 0.27, 0.46, 0.27, 3.9, 2.0, 3.4, 'D'],
  ['europe', 'champions-league', 'Benfica', 'Inter', '21:00', 0.31, 0.42, 0.27, 3.3, 2.25, 3.5, 'N'],
];

function pct(p) {
  return `${(p * 100).toFixed(2)}%`;
}

export function mockMatches(dateInfo) {
  const day = dateInfo || isoDate(new Date());
  return FIXTURES.map(([area, league, home, away, time, w, l, d, wo, lo, dro, result], i) => ({
    Country: area, League: league, MatchDate: day, MatchTime: `${day} ${time}:00`, MatchTimeRaw: `${day} ${time}:00`,
    HomeTeamCode: home, AwayTeamCode: away, DrawTeamCode: 'Draw', CountryOriginal: area, LeagueCodeOriginal: league,
    HomeTeamImagePath: 'Default', AwayTeamImagePath: 'Default', CountryImagePath: 'Default',
    WinProb: pct(w), LossProb: pct(l), DrawProb: pct(d), WinOdds: wo, LossOdds: lo, DrawOdds: dro,
    WinOddsPred: +(1 / w).toFixed(2), LossOddsPred: +(1 / l).toFixed(2), DrawOddsPred: +(1 / d).toFixed(2),
    WinFavor: +(wo - 1 / w).toFixed(2), LossFavor: +(lo - 1 / l).toFixed(2), DrawFavor: +(dro - 1 / d).toFixed(2),
    ActualResult: dateInfo && dateInfo < isoDate(new Date()) ? result : 'N',
    BetWinProb: BETS[i][0][0], BetDrawProb: BETS[i][0][1], BetLossProb: BETS[i][0][2],
    Prediction: BETS[i][1], Amount: BETS[i][2], PredId: 9000 + i,
  }));
}

export function mockPicks() {
  const day = isoDate(addDays(new Date(), 1));
  return [{
    PredId: 1, HomeTeamCode: 'Arsenal', AwayTeamCode: 'Chelsea', ResultValue: 'H', Amount: 10,
    MatchTime: `${day} 15:00:00`, HomeImagePath: 'Default', AwayImagePath: 'Default', DrawTeamCode: 'Draw',
    LeagueImagePath: 'Default', League: 'premier-league', Odds: 2.05, PotentialPayout: 20.5, ResultPicked: 'Arsenal',
    WinProb: 0.48, LossProb: 0.25, DrawProb: 0.27, WinOdds: 2.05, LossOdds: 3.7, DrawOdds: 3.6,
    WinFavor: 0, LossFavor: 0, DrawFavor: 0, WinOddsPred: 2.08, LossOddsPred: 4, DrawOddsPred: 3.7,
  }];
}
